import React, { useMemo, useRef, useState } from 'react';
import { useInView } from '../../hooks/useInView';

// ==========================================
// Компонент отдельной карточки
// ==========================================
const GalleryItem = ({ item, index, onOpen }) => {
  const [ref, inView] = useInView();
  const inner = useRef(null);
  const [imgError, setImgError] = useState(false);

  const handleMove = (e) => {
    if (!inner.current) return;
    const r = inner.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    inner.current.style.transform = `perspective(1000px) rotateY(${x * 5}deg) rotateX(${-y * 5}deg)`;
  };

  const handleLeave = () => {
    if (inner.current) {
      inner.current.style.transform = 'perspective(1000px) rotateY(0) rotateX(0)';
    }
  };

  return (
    <div className={`gallery-item ${inView ? 'visible' : ''}`} ref={ref} style={{ transitionDelay: `${index * 0.06}s` }}>
      <div className="gallery-item-inner" ref={inner} onMouseMove={handleMove} onMouseLeave={handleLeave}>
        {imgError ? (
          <div className="gallery-item-error">Нет фото</div>
        ) : (
          <img 
            src={item.url} 
            alt={item.title} 
            loading="lazy" 
            onError={() => setImgError(true)} 
          />
        )}
        <div className="gallery-item-overlay" onClick={() => onOpen(item)}>
          <div className="gallery-item-info">
            <div className="gallery-item-year">{item.year}</div>
            <div className="gallery-item-title">
              {item.title}
              {item.is_album && <span className="album-badge"></span>}
            </div>
            <div className="gallery-item-meta">
              <span className="gallery-item-type">{item.type}</span>
              {item.tag && <span className="gallery-item-tag">#{item.tag}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ==========================================
// Основной компонент галереи
// ==========================================
export const Gallery = ({ items = [], onOpen, viewMode = 'compact', setViewMode }) => {
  
  const filteredItems = useMemo(() => {
    if (viewMode === 'all') return items;
    
    const seenGroups = new Set();
    return items.filter(item => {
      if (!item.is_album) return true; // Одиночное фото - показываем
      
      if (!seenGroups.has(item.group_id)) {
        seenGroups.add(item.group_id);
        return true;
      }
      return false;
    });
  }, [items, viewMode]);

  return (
    <section className="gallery">
      <div className="section-header reveal">
        <div className="section-number">02 — КОЛЛЕКЦИЯ</div>
        <h2 className="section-title">Сокровища <em>архива</em></h2>
        <div className="section-line" />

        {/* 🔘 ПЕРЕКЛЮЧАТЕЛЬ РЕЖИМОВ */}
        <div className="view-mode-toggle">
          <button
            className={`mode-btn ${viewMode === 'compact' ? 'active' : ''}`}
            onClick={() => setViewMode('compact')}
          >
            Только обложки
          </button>
        </div>
      </div>

      {filteredItems.length === 0 ? (
        <div style={{ padding: '60px 20px', textAlign: 'center', color: 'var(--text-muted)' }}>
          Нет материалов для отображения
        </div>
      ) : (
        <div className="gallery-grid">
          {filteredItems.map((item, i) => (
            <GalleryItem key={`${item.pk_photo}-${i}`} item={item} index={i} onOpen={onOpen} />
          ))}
        </div>
      )}
    </section>
  );
};